document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.buy-now-wrapper');
  if (!wrapper) return;

  const qtyDisplay = wrapper.querySelector('.qty-display');
  const plusBtn = wrapper.querySelector('.qty-btn.plus');
  const minusBtn = wrapper.querySelector('.qty-btn.minus');
  const totalEl = wrapper.querySelector('.buy-now-total');
  const button = wrapper.querySelector('.buy-now-btn');

  const productVariants = JSON.parse(document.getElementById('buy-now-product-variants').textContent);

  function getCurrentVariant() {
    const selected = document.querySelector('.radios--input:checked');
    if (!selected) return null;

    const selectedValue = selected.value;
    return productVariants.find(v =>
      v.options.includes(selectedValue)
    );
  }

  function updatePrice() {
    const variant = getCurrentVariant();
    const qty = parseInt(qtyDisplay.textContent, 10);
    if (variant) {
      button.dataset.variantId = variant.id;
      totalEl.innerText = ((variant.price * qty) / 100).toFixed(2).replace('.', ',') + '€';
    }
  }

  plusBtn.addEventListener('click', () => {
    let qty = parseInt(qtyDisplay.textContent, 10);
    qty++;
    qtyDisplay.textContent = qty;
    updatePrice();
  });

  minusBtn.addEventListener('click', () => {
    let qty = parseInt(qtyDisplay.textContent, 10);
    if (qty > 1) {
      qty--;
      qtyDisplay.textContent = qty;
      updatePrice();
    }
  });

  button.addEventListener('click', () => {
    const variant = getCurrentVariant();
    const quantity = parseInt(qtyDisplay.textContent, 10);
    if (!variant || !variant.available) return;

    button.setAttribute('aria-busy', 'true'); // optionnel : indicateur de chargement

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity })
    })
    .then(() => {
      return fetch('/cart.js'); // force Shopify à rafraîchir l'état du panier
    })
    .then(() => {
      window.location.replace('/cart'); // évite les effets de cache
    })
    .catch(err => {
      console.error('Erreur panier :', err);
      button.removeAttribute('aria-busy');
    });
  });

  updatePrice();

  document.body.addEventListener('change', e => {
    if (e.target.classList.contains('radios--input')) {
      updatePrice();
    }
  });
});
